import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/AboutPage.css';

const AboutPage = () => {
  const { t } = useLanguage();

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>{t('about.title')}</h1>
          <p className="lead">{t('about.lead')}</p>
        </div>
      </section>

      <section className="about-content" style={{ backgroundImage: 'url(/historylogo-1.jpg)' }}>
        <div className="container">
          <div className="about-section">
            <div className="story-content">
              <h2>{t('about.storyTitle')}</h2>
              <p>
                {t('about.story1')}
              </p>
              <p>
                {t('about.story2')}
              </p>
              <p>
                {t('about.story3')}
              </p>
              <p>
                {t('about.story4')}
              </p>
            </div>
          </div>

          <div className="about-section">
            <h2>{t('about.missionTitle')}</h2>
            <p>
              {t('about.mission')}
            </p>
          </div>

          <div className="about-section">
            <h2>{t('about.visionTitle')}</h2>
            <p>
              {t('about.vision')}
            </p>
          </div>

          <div className="about-section">
            <h2>{t('about.valuesTitle')}</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>{t('about.value1Title')}</h3>
                <p>{t('about.value1Desc')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.value2Title')}</h3>
                <p>{t('about.value2Desc')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.value3Title')}</h3>
                <p>{t('about.value3Desc')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.value4Title')}</h3>
                <p>{t('about.value4Desc')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.value5Title')}</h3>
                <p>{t('about.value5Desc')}</p>
              </div>
              <div className="value-item">
                <h3>{t('about.value6Title')}</h3>
                <p>{t('about.value6Desc')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
